
    import '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/hooks/useGraphEvent.en.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-xflow-hooks-use-graph-event-demo-xflow-hooks-use-graph-event"],
  getter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/hooks/useGraphEvent.en.md?type=demo')
};